var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wrap-search-empty bg-white d-flex flex-column align-items-center",class:_vm.hasBorder ? 'border' : ''},[_c('img',{staticClass:"img-fluid d-block",attrs:{"src":require("../../assets/img/empty-icon.png"),"width":"70","alt":""}}),_c('span',{staticClass:"empty-content mt-6 text-gray600"},[_vm._v(_vm._s(_vm.$t(_vm.emptyText)))])])
}
var staticRenderFns = []

export { render, staticRenderFns }